/**
 * Type scale — the named sizes a block's heading may be set at.
 *
 * A locked vocabulary of five steps, of which each block offers only the ones
 * its design supports. XL/L/M/S/XS are the whole set and always will be: the
 * point of a named step is that "L" means the same KIND of thing everywhere,
 * so an author who has learnt one block's control has learnt them all.
 *
 * WHAT A STEP MEASURES IS PER BLOCK. Person grid's L is 80px; another block's
 * L is whatever its design says. That is deliberate — a shared pixel ladder
 * would either flatten every block's proportions to one scale or force blocks
 * to declare steps their design never drew.
 *
 * NO PIXEL VALUES LIVE HERE. The sizes are Tailwind classes and belong with the
 * component that draws them (see the class maps in `@diality/ui`'s blocks): a
 * number in this file plus a class string in that one is two sources of truth
 * for one size, and they drift the first time a designer retunes a ramp.
 */
/**
 * Every step there is, largest first. A block names a subset of these; nothing
 * outside the list is a step, so an unrecognised stored value is a stale value
 * rather than a sixth size.
 */
export const TYPE_SCALE_STEPS = ["xl", "l", "m", "s", "xs"];
/** What the author reads for the step itself — never the field's own label. */
export const TYPE_SCALE_LABEL = {
    xl: "XL",
    l: "L",
    m: "M",
    s: "S",
    xs: "XS",
};
/**
 * The step a block is drawn at, given what the author stored.
 *
 * The ONE coercion point, read by the renderer and by the inspector alike, so
 * the size a page draws and the size its control reports cannot disagree.
 *
 * Unset, empty, a step this block does not offer, and a step that is not a step
 * at all all resolve to the component's default. A renderer must tolerate a
 * stale stored value rather than throw — the same rule {@link ScalarSlot}
 * already states for dynamically-sourced choices, and for the same reason: what
 * a block offers can change after a page was authored against it.
 */
export function resolveTypeScale(scale, stored) {
    if (!stored)
        return scale.default;
    return scale.steps.includes(stored)
        ? stored
        : scale.default;
}
//# sourceMappingURL=type-scale.js.map